import React, { useState, useEffect } from "react";
import {
  Row, Col, Container,
  Collapse,
  NavbarToggler,
  NavItem,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import logo from "../../assets/Logo_White.png";
import WhatsappIcon from "../../assets/SM_WhatsApp.png";
import i18next from "i18next";
import "./Footer.css"
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
const Footer = () => {
  const { t } = useTranslation("footer");
  const [isOpen, setIsOpen] = useState(false);
  const isRtl = i18next.language === "ar";
  const toggle = () => {
    return setIsOpen(!isOpen);
  };
  const footer = [
    {
      id: 1,
      menu: [
        {
          id: 1,
          link: "https://www.kkf.org.sa/en/about-us/",
          subTitle: t("AboutUs"),
        },
        {
          id: 2,
          link: "https://www.kkf.org.sa/en/our-work/",
          subTitle: t("OurWork"),
        },
        {
          id: 3,
          link: "https://www.kkf.org.sa/en/our-story/",
          subTitle: t("OurStory"),
        },
        {
          id: 4,
          link: "https://www.kkf.org.sa/en/our-work/king-khalid-award/",
          subTitle: t("KingKhalidAward"),
        },
        {
          id: 5,
          link: "https://www.kkf.org.sa/en/insights/",
          subTitle: t("Insights"),
        },
        {
          id: 6,
          link: "https://www.kkf.org.sa/en/news/",
          subTitle: t("News"),
        },
      ],
    },
    {
      id: 2,
      menu: [
        {
          id: 1,
          link: "https://www.kkf.org.sa/en/events/",
          subTitle: t("Events"),
        },
        {
          id: 2,
          link: "https://www.kkf.org.sa/en/media/",
          subTitle: t("Media"),
        },
        {
          id: 3,
          link: "https://careers.kkf.org.sa",
          subTitle: t("Join_Us"),
        },
        {
          id: 4,
          link: "https://www.kkf.org.sa/en/contact/",
          subTitle: t("Contact"),
        },
      ],
    }
  ];
  const footerIcons = [
    {
      id: 1,
      socialIcon: "uil uil-youtube",
      link: "https://www.youtube.com/user/kingkhalidfoundation",
    },
    {
      id: 2,
      socialIcon: "uil uil-instagram",
      link: "https://www.instagram.com/kkfoundation/",
    },
    {
      id: 3,
      socialIcon: "uil uil-twitter",
      link: "https://twitter.com/kkfoundation",
    },
    {
      id: 4,
      socialIcon: "uil uil-facebook-f",
      link: "https://www.facebook.com/KKFoundation",
    },
    {
      id: 5,
      socialIcon: "uil uil-linkedin-alt",
      link: "https://www.linkedin.com/company/king-khalid-foundation",
    },
  ];
  return (
    <React.Fragment>
      <section className="bg-footer" style={{ background: "rgb(26, 52, 40)", paddingRight: "30px", paddingLeft: "30px" }}>
        <nav
          className={"navbar navbar-expand-lg p-0"}
          id="navigation"
          style={{ direction: "ltr", background: "rgb(26, 52, 40)" }}
        >
          <Container fluid className="custom-container">

            <Row className="col-lg-4 me-lg-6">
              <Col className="text-start">
                <Row>
                  <Col xs="auto p-2" style={{ color: "#f6f3ee" }}  className={isRtl ? 'order-first' : 'order-last'}>
                    <h5> {t("TogetheForSustainableImpact")}</h5>
                  </Col>
                  <Col xs="auto p-0" className={isRtl ? 'order-last' : 'order-first'}>
                    <div className={isRtl ? 'smallTriangle' : 'smallTriangleEn'}></div>
                  </Col>

                </Row>
              </Col>
              <Row>
                <Col xs="auto p-0">
                  <a href="https://twitter.com/kkfoundation" style={{ cursor: "pointer" }} target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" width="30" height="30">
                      <defs>
                        <style>
                          {`.cls-1 {
            opacity: 0.3;
          }

          .cls-1, .cls-2 {
            fill: #fff;
            stroke-width: 0px;
          }`}
                        </style>
                      </defs>
                      <ellipse className="cls-1" cx="36" cy="36" rx="27.74" ry="27.46" />
                      <path className="cls-2" d="M25.77,23.31h2.9l17.65,25.47h-2.9l-17.66-25.47ZM46.96,20.47l-9.23,10.82-7.37-10.82h-9.78l11.71,17.19-11.83,13.87h3.73l9.76-11.44,7.79,11.44h9.78l-12.14-17.81,11.3-13.25h-3.74Z" />
                    </svg>
                  </a>
                </Col>

                <Col xs="auto p-0">
                  <a href="https://www.instagram.com/kkfoundation/" style={{ cursor: "pointer" }} target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" width="30" height="30">
                      <defs>
                        <style>
                          {`.cls-1 {
            opacity: 0.3;
          }

          .cls-1, .cls-2 {
            fill: #fff;
            stroke-width: 0px;
          }`}
                        </style>
                      </defs>
                      <ellipse className="cls-1" cx="36" cy="36" rx="27.74" ry="27.46" />
                      <g id="Instagram">
                        <path className="cls-2" d="M35.99,31.81c-2.3,0-4.18,1.88-4.18,4.18,0,2.3,1.88,4.18,4.18,4.18,2.3,0,4.18-1.88,4.18-4.18,0-2.31-1.88-4.18-4.18-4.18Z" />
                        <path className="cls-2" d="M51.42,29.61c-.02-.9-.14-1.8-.36-2.68-.42-1.66-1.24-3.09-2.53-4.23-1.35-1.19-2.95-1.79-4.69-2.01-.88-.11-1.78-.16-2.67-.18-1.75-.04-3.5-.05-5.24-.05-2.07,0-4.14-.02-6.2.08-.78.04-1.56.11-2.33.27-1.71.36-3.21,1.1-4.43,2.37-1.29,1.34-1.95,2.97-2.23,4.78-.16,1-.19,2.01-.21,3.01-.03,1.65-.04,3.3-.04,4.94,0,2.29-.03,4.59.11,6.88.06.98.22,1.95.52,2.89.63,1.93,1.81,3.43,3.55,4.46,1.28.76,2.7,1.12,4.17,1.22,1.01.07,2.02.12,3.03.13,3.29.02,6.59.06,9.88-.04,1.04-.03,2.07-.1,3.09-.34,1.28-.3,2.45-.82,3.47-1.66,1.72-1.41,2.62-3.28,2.96-5.45.15-1,.19-2.01.2-3.01.03-1.67.04-3.33.06-5.72-.03-1.41-.06-3.54-.11-5.67ZM35.98,43.97c-4.4,0-7.96-3.57-7.96-7.97,0-4.41,3.56-7.97,7.97-7.97,4.41,0,7.97,3.57,7.96,7.98,0,4.41-3.57,7.97-7.98,7.97ZM45.05,29.76c-1.48,0-2.7-1.22-2.7-2.71,0-1.48,1.22-2.68,2.7-2.67,1.48,0,2.68,1.21,2.67,2.7,0,1.47-1.21,2.67-2.68,2.68Z" />
                      </g>
                    </svg>
                  </a>
                </Col>
                <Col xs="auto p-0">
                  <a href="https://www.linkedin.com/company/king-khalid-foundation" style={{ cursor: "pointer" }} target="_blank">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" width="30" height="30">
                      <defs>
                        <style>
                          {`.cls-1 {
            opacity: 0.3;
          }

          .cls-1, .cls-2 {
            fill: #fff;
            stroke-width: 0px;
          }`}
                        </style>
                      </defs>
                      <ellipse className="cls-1" cx="36" cy="36" rx="27.74" ry="27.46" />
                      <g id="Linkedin">
                        <path className="cls-2" d="M37.95,31.19v2.77c.19-.26.36-.48.53-.7,1.54-1.91,3.57-2.68,5.97-2.55,1.22.07,2.38.35,3.43.99,1.75,1.05,2.77,2.62,3.26,4.57.27,1.04.38,2.1.38,3.17,0,3.81,0,7.62,0,11.42,0,.06,0,.13,0,.2h-6.61c0-.07,0-.14,0-.21,0-3.55,0-7.1,0-10.65,0-.79-.1-1.57-.38-2.31-.48-1.25-1.4-1.85-2.72-1.95-2.36-.18-3.88,1.98-3.86,3.7.02,1.44,0,2.88,0,4.32,0,2.3,0,4.59,0,6.89,0,.06,0,.13,0,.21h-6.59v-19.87h6.6Z" />
                        <path className="cls-2" d="M20.57,31.19h6.59v19.88h-6.59v-19.88Z" />
                        <circle className="cls-2" cx="23.87" cy="24.33" r="3.4" />
                      </g>
                    </svg>
                  </a>
                </Col>
                <Col xs="auto p-0">
                  <a href="https://www.tiktok.com/discover/kk-foundation" style={{ cursor: "pointer" }} target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" width="30" height="30">
                      <defs>
                        <style>
                          {`.cls-1 {
            opacity: 0.3;
          }

          .cls-1, .cls-2 {
            fill: #fff;
            stroke-width: 0px;
          }`}
                        </style>
                      </defs>
                      <ellipse className="cls-1" cx="36" cy="36" rx="27.74" ry="27.46" />
                      <path id="Tiktok" className="cls-2" d="M42.37,20.47h-5.48s-.07,21.02-.12,21.52c-.11,1.11-.77,2.13-1.62,2.83-.81.67-1.84,1.09-2.9,1.11-2.46.06-4.88-2.17-4.85-4.74.03-2.27,1.91-4.49,4.17-4.67.25-.02.6-.03.94-.04v-5.57c-.65,0-1.53.02-2.46.16-4.22.86-7.68,4.49-8.16,8.76-.39,3.47.59,6.49,3.24,8.91,3.44,3.14,8.36,3.72,12.31,1.29,3.21-1.97,4.9-4.9,4.97-8.67.07-3.66.05-9.71.07-9.99,2.38,1.61,4.9,2.43,7.7,2.48v-5.44c-4.54-.76-7.39-3.13-7.82-7.95Z" />
                    </svg>
                  </a>
                </Col>
                <Col xs="auto p-0">
                  <a href="http://www.youtube.com/user/kingkhalidfoundation" style={{ cursor: "pointer" }} target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" width="30" height="30">
                      <defs>
                        <style>
                          {`.cls-1 {
            opacity: 0.3;
          }

          .cls-1, .cls-2 {
            fill: #fff;
            stroke-width: 0px;
          }`}
                        </style>
                      </defs>
                      <ellipse className="cls-1" cx="36" cy="36" rx="27.74" ry="27.46" />
                      <path id="Youtube" className="cls-2" d="M50.88,28.47c-.36-1.35-1.41-2.4-2.75-2.76-2.42-.65-12.14-.65-12.14-.65,0,0-9.71,0-12.14.65-1.34.36-2.39,1.42-2.75,2.76-.65,2.44-.65,7.53-.65,7.53,0,0,0,5.09.65,7.53.36,1.35,1.41,2.4,2.75,2.76,2.42.65,12.14.65,12.14.65,0,0,9.71,0,12.14-.65,1.34-.36,2.39-1.42,2.75-2.76.65-2.44.65-7.53.65-7.53,0,0,0-5.09-.65-7.53ZM32.82,40.62v-9.24l8.12,4.62-8.12,4.62Z" />
                    </svg>
                  </a>
                </Col>
                
                <Col xs="auto p-0">
                <a href="https://wa.me/+966554960011" style={{ cursor: "pointer" }} target="_blank">
                <img
                src={WhatsappIcon}
                alt="logo"
                width="30"
              />
                </a>
                </Col>
              </Row>
            </Row>


        

            <a
              className="navbar-brand text-dark fw-bold me-auto"
              target="_blank"
              rel="noreferrer"
              href={
                isRtl ? "https://www.kkf.org.sa/" : "https://www.kkf.org.sa/en/"
              }
            >
              <img
                src={logo}

                alt="logo"
                width="320"
                className="logo-dark"
              />
              <img
                src={logo}

                alt="logo"
                width="320"
                className="logo-light"
              />
            </a>
          </Container>
        </nav>
      </section>
      <div className="" style={{ background: "rgb(26, 52, 40)" }}>
        <Row className="justify-content-between align-items-center w-100">
          <Col lg={7} className={isRtl ? 'text-end order-last' : 'text-start order-first'}>
            {/* Your main content here */}
          </Col>
          <Col lg={5} className={isRtl ? 'text-start order-first' : 'text-end order-last'}>
            <p className="mb-0 footer-link-color mx-5">
              <p className="copyright footer-link-color">{t("copyright")}</p>
            </p>
          </Col>
        </Row>

      </div>
    </React.Fragment>
  );
};

export default Footer;
